import React, { useState, useRef } from "react"
import ReactDOM from "react-dom"
import styled from "styled-components"
import { useIntl } from "gatsby-plugin-react-intl"
import { usePopper } from "react-popper"

import Tooltip from "./Tooltip"

const CopyShareInput = styled.input`
  display: none;
`

const CopyShareButton = styled.button`
  appearance: none;
  background: transparent;
  border: none;
  cursor: pointer;
  margin: 0;
  outline: none;
  padding: 0;
`

const CopyShare = ({ copy, children }) => {
  const inputEl = useRef(null)
  const intl = useIntl()
  const [showTooltip, setShowTooltip] = useState(false)
  const [referenceElement, setReferenceElement] = useState(null)
  const [popperElement, setPopperElement] = useState(null)
  const [arrowElement, setArrowElement] = useState(null)
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    modifiers: [
      { name: "arrow", options: { element: arrowElement, padding: 5 } },
      {
        name: "offset",
        options: {
          offset: [0, 10],
        },
      },
    ],
    placement: "top",
  })

  const handleFocus = (event) => {
    // Persist React synthetic event
    // See https://reactjs.org/docs/events.html#event-pooling
    const target = event.target

    // Timeout because iOS refuses to select the text otherwise
    setTimeout(() => {
      target.setSelectionRange(0, 9999)
    }, 0)
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(copy)
    setShowTooltip(true)

    setTimeout(() => {
      setShowTooltip(false)
    }, 2000)
  }

  return (
    <>
      <CopyShareInput
        onFocus={handleFocus}
        readOnly
        ref={inputEl}
        value={copy}
      />
      <CopyShareButton
        aria-label={intl.formatMessage({ id: "copyShare.copy" })}
        onClick={handleCopy}
        ref={setReferenceElement}
        title={intl.formatMessage({ id: "copyShare.copy" })}
      >
        {children}
      </CopyShareButton>

      {showTooltip &&
        ReactDOM.createPortal(
          <Tooltip
            arrowRef={setArrowElement}
            forwardRef={setPopperElement}
            styles={styles}
            text={intl.formatMessage({ id: "copyShare.copySuccess" })}
            {...attributes.popper}
          ></Tooltip>,
          document.querySelector("#portal")
        )}
    </>
  )
}

export default CopyShare
